import { Box, useTheme, Typography, useMediaQuery } from "@mui/material";
import React from "react";
import { tokens } from "../../Theme/theme";
import { Header } from "../global/Header";
import Statbox from "./Statbox";
import DownloadIcon from "@mui/icons-material/Download";
import DownloadDoneIcon from "@mui/icons-material/DownloadDone";
import StorefrontIcon from "@mui/icons-material/Storefront";
import PersonPinIcon from "@mui/icons-material/PersonPin";
import BarChart from "../Charts/BarChart";
import PieChart from "../Charts/PieChart";
import { useEffect } from "react";
import { useState } from "react";
import LineChart from "../Charts/LineChart";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../../NetworkConfig/ApiConfig";
import { format, utcToZonedTime } from "date-fns-tz";
import { CircleLoader, BounceLoader } from 'react-spinners'



const Dashboard = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [DashboardState, setDashboardState] = useState(null);
  const [userCount, setUserCount] = useState(0);
  const [ActiveUsersCount, setActiveUsersCount] = useState(0);
  const [ActiveYesterdayCount, setActiveYesterdayCount] = useState(0)
  // const [loading, setloading] = useState(true);
  const [ActiveUsersChartData, setActiveUsersChartData] = useState(null)
  const [error, seterror] = useState("Loading....");
  const isMobileScreen = useMediaQuery('(max-width:500px)');
  const isTabScreen = useMediaQuery('(max-width:1200px)')
  const [userProfile, setUserProfile] = useState({})

  const navigate = useNavigate()

  const FetchDashboardDetails = async () => {
    // setloading(true);
    const token = localStorage.getItem("token");
    const response = await fetch(`${BASE_URL}/dashboard/details/`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "auth-token": token,
      },
    });
    const data = await response.json();
    if (data.success === true) {
      setDashboardState(data.response);
      setUserCount(data.response[0]["totalUsers"])
      console.log(data);
      console.log(DashboardState);
      // setloading(false);
      return;
    }
    if (data.success === false) {
      alert("error")
      seterror(data.response);
      return;
    }
  };

  const calculatePercentageChange = (today, yesterday) => {
    if (yesterday === 0 && today == 0) return 0;
    if (yesterday === 0 && today > 0) return 100;
    if (today == 0) return -100;
    const percentageChange = ((today - yesterday) / yesterday) * 100;
    return percentageChange.toFixed(2); // Limit to 2 decimal places
  };

  const FetchData = async () => {
    // setloading(true);
    const token = localStorage.getItem("token");
    const Datenow = new Date().toISOString();
    const timeZone = "Asia/Kolkata"
    const zonedDate = utcToZonedTime(Datenow, timeZone);
    const istTime = format(zonedDate, "yyyy-MM-dd'T'HH:mm:ssXXX", { timeZone });

    console.log(istTime)

    const response = await fetch(
      `${BASE_URL}/dashboard/active-users`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "auth-token": token,
        },
      }
    );
    const data = await response.json();
    console.log(data)
    if (data.success === true) {
      setActiveUsersCount(data.today);
      setActiveYesterdayCount(data.yesterday)
      // console.log(UsersState);

      return; // setloading(false);
    }
    if (data.success === false) {
      // seterror(data.response);
      return;
    }
  };

  const FetchActiveUsersGraphData = async () => {
    // setloading(true);
    const token = localStorage.getItem("token");
    const Datenow = new Date();
    const response = await fetch(
      `${BASE_URL}/active/getactiveusersdata/${Datenow.toISOString()}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "auth-token": token,
        },
      }
    );
    const data = await response.json();
    console.log(data)
    if (data.success === true) {
      setActiveUsersChartData(data.response.data)
      console.log(data);
      // console.log(UsersState);

      return; // setloading(false);
    }
    if (data.success === false) {
      seterror(data.response);
      return;
    }
  };
  useEffect(() => {
    async function getUserProfile() {
      const profile = localStorage.getItem("profile");
      setUserProfile(JSON.parse(profile))
    }
    getUserProfile()
    FetchDashboardDetails();
    FetchData();
    FetchActiveUsersGraphData()

  }, []);
  if (!DashboardState) {
    return <Box sx={{ alignItems: 'center', justifyContent: 'center', display: 'flex', height: "50%" }}>

      <BounceLoader size={"40px"} color={"#943bff"} />


    </Box>;
  }
  return (
    <Box m="20px" sx={{
      flexDirection: "column",
      display: "flex"
    }}>
      <Box
        display={"flex"}
        justifyContent="space-between"
        alignItems={"center"}
      >
        <Header
          title={`Welcome Back, ${userProfile.UserName ? userProfile.UserName.split(" ")[0] : ""} 👋`}
          subtitle={"Here is the latest cerkle report"}
        />
      </Box>

      <Box
        display={"grid"}
        gridTemplateColumns="repeat(10,1fr)"
        gridAutoRows={"100px"}
        pb={"20px"}
        alignSelf={"stretch"}
        gap={isMobileScreen ? "20px" : "35px"}
      >
        {/* ROW 1 */}
        <Box
          gridColumn={isMobileScreen ? "span 10" : isTabScreen ? "span 5" : "span 2"}
          sx={{
            border: "1.7px solid transparent",
            background:
              "linear-gradient(#ffffff00 0 0) padding-box, linear-gradient(#0b0b0f 0 0) padding-box, linear-gradient(45deg,#943bff, rgba(214, 152, 36, 1)) border-box",
            borderRadius: "15px",
          }}
          display="flex"
          alignItems={"center"}
          justifyContent="center"
        >
          <Statbox
            title={userCount}
            subtitle="Total Users"
            icon={
              <DownloadDoneIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }

            onClick={() => {
              navigate("/admin/users")
            }}
            users={true}
            report={`${DashboardState[0]["totalUsersThisMonth"]} this month`}
          />
        </Box>
        <Box
          sx={{
            background: "#ffffff08",
            borderRadius: "20px",
            border: "1.5px solid #aaaaaa05",
          }}
          gridColumn={isMobileScreen ? "span 10" : isTabScreen ? "span 5" : "span 2"}
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems={"center"}
          justifyContent="center"
        >
          <Statbox
            // todayonboardusers
            title={DashboardState[0]["todayonboardusers"]}
            subtitle="Joined Today"
            onClick={() => {

            }}
            icon={
              <DownloadIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
            report={calculatePercentageChange(DashboardState[0]["todayonboardusers"], DashboardState[0]["yesterdayonboardusers"])}
            reportSuffix={calculatePercentageChange(DashboardState[0]["todayonboardusers"], DashboardState[0]["yesterdayonboardusers"]) > 0
              ? " more than yesterday" : (calculatePercentageChange(DashboardState[0]["todayonboardusers"], DashboardState[0]["yesterdayonboardusers"]) == 0
                ? "Same as yesterday" : " less than yesterday")
            }
            users={false}
          />
        </Box>
        <Box
          sx={{
            background: "#ffffff08",
            borderRadius: "20px",
            border: "1.5px solid #aaaaaa05",
          }}
          gridColumn={isMobileScreen ? "span 10" : isTabScreen ? "span 5" : "span 2"}
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems={"center"}
          justifyContent="center"
        >
          <Statbox
            title={ActiveUsersCount}
            subtitle="Active Today"
            onClick={() => {
              navigate("/admin/activeusers")
            }}
            icon={
              <PersonPinIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
            users={false}
            report={calculatePercentageChange(ActiveUsersCount, ActiveYesterdayCount)}
            reportSuffix={calculatePercentageChange(ActiveUsersCount, ActiveYesterdayCount) > 0
              ? " more than yesterday" : (calculatePercentageChange(ActiveUsersCount, ActiveYesterdayCount) == 0 ? "Same as yesterday" : " less than yesterday")
            }
          />
        </Box>
        <Box
          sx={{
            background: "#ffffff08",
            borderRadius: "20px",
            border: "1.5px solid #aaaaaa05",
          }}
          gridColumn={isMobileScreen ? "span 10" : isTabScreen ? "span 5" : "span 2"}
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems={"center"}
          justifyContent="center"
        >
          <Statbox
            title={DashboardState[0]["totalCommunities"]}
            subtitle="Communities"
            icon={
              <StorefrontIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
            reportSuffix={""}
            users={false}
          />
        </Box>
        <Box
          sx={{
            background: "#ffffff08",
            borderRadius: "20px",
            border: "1.5px solid #aaaaaa05",
          }}
          gridColumn={isMobileScreen ? "span 10" : isTabScreen ? "span 5" : "span 2"}
          backgroundColor={colors.primary[400]}
          display="flex"
          alignItems={"center"}
          justifyContent="center"
        >
          <Statbox
            title={DashboardState[0]["totalSpaces"]}
            subtitle="Total Spaces"
            icon={
              <StorefrontIcon
                sx={{ color: colors.greenAccent[600], fontSize: "26px" }}
              />
            }
            reportSuffix={""}
            users={false}
          />
        </Box>


        {/* ROW 2 */}
        <Box
          // key={`${transaction.txId}-${i}`}
          gridColumn={(isMobileScreen || isTabScreen) ? "span 10" : "span 6"}
          gridRow="span 4"
          display="flex"
          alignItems="center"
          px="15px"
          py={"8px"}
          target={"_blank"}
          sx={{
            background: "#ffffff08",
            borderRadius: "20px",
            border: "1.5px solid #aaaaaa05",
            textDecoration: 'none', paddingY: "20px", flexDirection: (isMobileScreen || isTabScreen) ? 'column' : 'row',
            display: 'flex', position: 'relative'

          }}>

          <Box sx={{
            flex: 1, display: 'flex', flexDirection: 'column', height: (isMobileScreen || isTabScreen) ? "300px" : "400px", marginBottom: "40px",
            width: (isMobileScreen || isTabScreen) ? "100%" : "100%",
          }}>

            <Typography fontSize={"16px"} fontFamily={'poppins-reg'} color={"#ffffff"}
              display={'flex'} style={{ marginInline: "10px" }}
            >
              Last 10 days active users
            </Typography>

            <LineChart
              // isDashboard={true}
              color={[
                "#ff6b00"
              ]}
              enableArea={true}
              data={ActiveUsersChartData}
            />
          </Box>
        </Box>
        <Box
          gridColumn={isMobileScreen ? "span 10" : "span 4"}
          gridRow="span 4"
          sx={{
            background: "#ffffff08",
            borderRadius: "20px",
            border: "1.5px solid #aaaaaa05",
            flexDirection: "column",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >

          <Box height="450px" m="0 0 0 0" sx={{
            alignItems: "center", display: "flex", justifyContent: "center",
            position: "relative", width: "100%"
          }}>
            <PieChart data={DashboardState[0]["GenderChart"]} />
            <Typography
              style={{
                position: "absolute", display: "flex", alignSelf: "center", marginBottom: "30px",
                fontSize: isMobileScreen ? "13px" : "16px"
              }}
              fontFamily={'poppins-reg'}
              color={"#ffffff"}
            >Users by Gender
            </Typography>
          </Box>
        </Box>

        <Box
          gridColumn={isMobileScreen ? "span 10" : "span 4"}
          gridRow="span 4"
          sx={{
            background: "#ffffff08",
            borderRadius: "20px",
            border: "1.5px solid #aaaaaa05",
          }}
        >
          <Box
            mt="25px"
            p="0 30px"
            display="flex "
            justifyContent="space-between"
            alignItems="center"
          >
            <Box>
              <Typography
                variant="h5"
                fontFamily={"poppins-mid"}
                color={colors.grey[100]}
              >
                Users By Age
              </Typography>
            </Box>
          </Box>
          <Box height="450px" m="-20px 0 0 0">
            <BarChart
              // isDashboard={true}
              data={DashboardState[0]["Agedata"]}
            />
          </Box>
        </Box>

        <Box
          // key={`${transaction.txId}-${i}`}
          gridColumn={(isMobileScreen || isTabScreen) ? "span 10" : "span 6"}
          gridRow="span 4"
          display="flex"
          alignItems="center"
          px="15px"
          py={"8px"}
          target={"_blank"}
          sx={{
            background: "#ffffff08",
            borderRadius: "20px",
            border: "1.5px solid #aaaaaa05",
            textDecoration: 'none', paddingY: "20px", flexDirection: (isMobileScreen || isTabScreen) ? 'column' : 'row',
            display: 'flex', position: 'relative'

          }}>

          <Box sx={{
            flex: 1, display: 'flex', flexDirection: 'column', height: (isMobileScreen || isTabScreen) ? "300px" : "400px", marginBottom: "40px",
            width: (isMobileScreen || isTabScreen) ? "100%" : "100%",
          }}>

            <Typography fontSize={"16px"} fontFamily={'poppins-reg'} color={"#ffffff"}
              display={'flex'} style={{ marginInline: "10px" }}
            >
              Accounts Created
            </Typography>

            <LineChart
              // isDashboard={true}
              data={DashboardState[0]["registrationsChart"].data}
              color={[
                "#ff6b00"
              ]}
              enableArea={true}
            />
          </Box>
        </Box>

      </Box>
    </Box>
  );
};

export default Dashboard;
